var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("当前位置： "+_vm._s(_vm.latitude)+" "+_vm._s(_vm.longitude))]),_c('div',{attrs:{"id":"content-map"}}),_c('div',{attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }